/* eslint 'array-callback-return': 'off', 'jsx-a11y/anchor-is-valid': 'off', eqeqeq: 'off'  */
import React, { Component } from 'react';
import { Col, Button, FormGroup, Table } from 'reactstrap';
import { connect } from "react-redux";
import ErrorGif from '../../../../../../Assets/images/Error.gif';
import { GetBuildingsDetailsList, UpdateHoliday } from '../../../../../../action/HolidaysAction';
import { closeModalPopUp } from '../../../../../../action/modalStateAction';
import SelectAllCheckboxes from '../../../../../../Resources/SelectAllCheckboxes';
import SearchInput, { createFilter } from 'react-search-input';
import Flatpickr from 'react-flatpickr';
import Conversions from '../../../../../../Resources/Conversions';

let Holiday_Name = null, Holiday_Date = null, SelectedBuildingId = [], Building_IDs = [], IsModalClose = false, IsBuildingValid = false, IsEdited = false;
const KEYS_TO_FILTERS = ['siteName', 'addrCity', 'addrStateProvince'];

class EditHolidayForm extends Component {
    componentWillMount() {
        this.setState({ HolidayID: this.props.parentToChildData[0] });
    }
    componentDidMount() {
        this.props.GetBuildingsDetailsList();
        if(Holiday_Date != null){
            this.setState({
                Holiday_Date: new Date(Holiday_Date)
            });
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            HolidayID: this.props.parentToChildData[0],
            FormDisplay: true,
            error: false,
            searchTerm: '',
            Holiday_Date :new Date()
        };
        this.updateHoliday = this.updateHoliday.bind(this);
        this.BuildingSave = this.BuildingSave.bind(this);
        this.CloseModal = this.CloseModal.bind(this);
        this.nextForm = this.nextForm.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.searchUpdated = this.searchUpdated.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    nextForm() {
        Holiday_Name = this.refs.holiday_name.value;
        Holiday_Date = this.state.Holiday_Date;
        IsEdited = true;
        this.setState({
            FormDisplay: false
        });
    }

    handleChange(date) {
        this.setState({
            Holiday_Date: new Date(date)
        });
    }

    closePopup() {
        this.setState({
            FormDisplay: true,
            searchTerm:''
        });
    }
    CloseModal() {
        this.props.closeModalPopUp("close");
        IsEdited = false;
    }
    BuildingSave(Rows) {
        IsEdited = true;
        IsBuildingValid = false;
        var IsAnySelected = false;
        if (Rows != null) {
            SelectedBuildingId = [];
            for (let i = 0; i < Rows.length; i++) {
                var id = Rows[i].props.children[0].props.children.ref;
                if (this.refs[id].checked) {
                    SelectedBuildingId.push(this.refs[id].value);
                    IsAnySelected = true;
                }
            }
        }
        if (IsAnySelected) {
            this.closePopup();
        } else {
            IsBuildingValid = true;
            this.setState({ error: false });
        }
    }
    updateHoliday() {
        IsModalClose = false;
        var IsValidHoliday = true;
        var New_Holiday_Name = this.refs.holiday_name.value;

        let twoDigitMonth = (this.state.Holiday_Date.getMonth() + 1).toString().length > 1 ? (this.state.Holiday_Date.getMonth() + 1) : "0" + (this.state.Holiday_Date.getMonth() + 1).toString();
        let twoDigitDay = this.state.Holiday_Date.getDate().toString().length > 1 ? this.state.Holiday_Date.getDate() : "0" + this.state.Holiday_Date.getDate().toString();

        var New_Holiday_Date = twoDigitMonth + "/" + twoDigitDay + "/" + this.state.Holiday_Date.getFullYear();

        //Past Date Validation
        if (New_Holiday_Date != null) {
            var l_date = new Date();
            l_date.setHours(0, 0, 0, 0);//discard the time
            var SpecialTo = new  Date(New_Holiday_Date).setHours(0, 0, 0, 0);
            if (Number(SpecialTo) < Number(l_date)) {
                IsValidHoliday = false;
            }
        }

        if (New_Holiday_Name == null || New_Holiday_Name == "") {
            IsValidHoliday = false;

        }
        else if (New_Holiday_Date == null || New_Holiday_Date == "") {
            IsValidHoliday = false;

        }
        else if (Building_IDs == null || Building_IDs == "") {
            IsValidHoliday = false;
        }
        if (IsValidHoliday) {
            var editData = {
                "HolidayId": this.state.HolidayID,
                "HolidayName": New_Holiday_Name,
                "BuildingIds": Building_IDs,
                "HolidayDate": New_Holiday_Date
            };
            this.props.UpdateHoliday(editData);
            IsEdited = false;
            this.props.closeModalPopUp("close");
        } else {
            IsModalClose = true;
            this.setState({ error: false });
        }
    }

    render(getResponse, Response_of_Building, getLabels, UserPreference_response) {
        let modal_form, modal_form_1, modal_form_2, Available_Buildings = null, holidaydts;
        let Holiday_BuildingIds = null;
        let Buildingsdt = null;
        let hoId = this.state.HolidayID;

        let label = this.props.getLabels;
        let PreferedDateFormat = this.props.UserPreference_response;
        let DtFormat = Conversions.UserPreferenceDateFormat(PreferedDateFormat);

        if (this.props.getResponse != undefined) {
            if (this.props.getResponse.HolidayList.length) {
                holidaydts = this.props.getResponse.HolidayList;
                holidaydts = holidaydts.filter(function (item) {
                    return item.holidayId === hoId
                });

                if (holidaydts !== undefined && holidaydts !== null && !IsEdited) {
                    holidaydts = holidaydts[0];
                    Holiday_Name = holidaydts.holidayName;

                    //var HDate = new Date(holidaydts.holidayDate);
                    //var year = HDate.getFullYear();
                    //var month = HDate.getMonth() + 1;
                    //var dt = HDate.getDate();
                    Holiday_Date = new Date(holidaydts.holidayDate);

                    // if (dt < 10) { dt = '0' + dt; }
                    // if (month < 10) { month = '0' + month; }
                    // this.state.Holiday_Date = year + '-' + month + '-' + dt;
                    // this.state.Holiday_Date = new Date(holidaydts.holidayDate);

                    SelectedBuildingId = holidaydts.buildingIds;
                }
            }
        }
        if (this.props.Response_of_Building != undefined) {
            let buildingdts = this.props.Response_of_Building.BuildingsDetailsList;
            

            if (SelectedBuildingId != undefined && SelectedBuildingId.length) {
                Holiday_BuildingIds = [];
                for (let i = 0; i < SelectedBuildingId.length; i++) {
                    Holiday_BuildingIds.push(SelectedBuildingId[i]);
                }
            }

            Building_IDs = Holiday_BuildingIds;
            if (this.state.FormDisplay) {
                // buildingdts = buildingdts.filter(function (item) {
                //     return Holiday_BuildingIds.join(',').search(item.siteID) !== -1
                // });
                if (buildingdts != undefined && buildingdts != null && buildingdts.length) {
                    buildingdts = buildingdts.filter((obj) => {
                        for (let i = 0, length = Holiday_BuildingIds.length; i < length; i++) {
                            if (String(obj.siteID) === Holiday_BuildingIds[i])
                                return true;
                        }
                    })
                    Buildingsdt = buildingdts.map(el => (
                        <tr>
                            <td>{el.siteName}</td>
                            <td>{el.addrCity}</td>
                            <td>{el.addrStateProvince}</td>
                        </tr>
                    ));
                }
            } else {
                let Data = [],FilteredData = [];
                Data = buildingdts;

                    FilteredData = Data.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
                    if (FilteredData.length > 0) { buildingdts = FilteredData } else { buildingdts = Data };

                Available_Buildings = buildingdts.map(el => {
                    if (Holiday_BuildingIds.filter(obj => obj === String(el.siteID)).length === 0) {
                        return <tr>
                            <th><input type="checkbox" ref={"ref_" + el.siteID} value={el.siteID} className="buildings_child_Check_box" /></th>
                            <td>{el.siteName}</td>
                            <td>{el.addrCity}</td>
                            <td>{el.addrStateProvince}</td>
                        </tr>
                    } else {
                        return <tr>
                            <th><input type="checkbox" defaultChecked="true" ref={"ref_" + el.siteID} value={el.siteID} className="buildings_child_Check_box" /></th>
                            <td>{el.siteName}</td>
                            <td>{el.addrCity}</td>
                            <td>{el.addrStateProvince}</td>
                        </tr>
                    }
                });
            }

            // validations
            if (IsModalClose) {
                var errormsg = <p className="error_msg">
                    <img src={ErrorGif} alt="Trane Logo" />
                    {label['CheckTemperatureAdjustment.Text'] !== undefined ? label['CheckTemperatureAdjustment.Text'] : "Error: You left necessary fields blank or entered invalid values."}
                </p>
            }
            if (IsBuildingValid) {
                var errormsg1 = <p className="error_msg">
                    <img src={ErrorGif} alt="Trane Logo" />
                    Error: Please Select one or more building to perform this action.
                </p>
            }
        }

        modal_form_1 = <div className="ViewHoliday_Modal">
            <h4 id="lbl_Holiday_EditHoliday_Title" className="Modal_form_title">{label['ManageHolidays.EditHolidayHeader.Text'] !== undefined ? label['ManageHolidays.EditHolidayHeader.Text'] : "Edit Holiday"}</h4>
            {errormsg}
            <div className="Modal_form_group ">
                <label id="lbl_Holiday_EditHoliday_HolidayName" className="ChangeLimits_Modal_label">{label['ManageHolidays.HolidayName.Text'] !== undefined ? label['ManageHolidays.HolidayName.Text'] : "Holiday Name"}</label>
                <input id="txt_Holiday_EditHoliday_HolidayName" ref='holiday_name' className="ChangeLimits_Modal_input default-input" defaultValue={Holiday_Name} />
            </div>
            <div className="Modal_form_group ">
            <tr>
                <td> <label id="lbl_Holiday_EditHoliday_HolidayDate" className="ChangeLimits_Modal_label">{label['ManageHolidays.Date.Text'] !== undefined ? label['ManageHolidays.Date.Text'] : "Date"}</label></td>
                <td className="paddingleft"> <Flatpickr value={this.state.Holiday_Date} ref="holiday_date" onChange={this.handleChange} options={{minDate: "today", dateFormat: DtFormat}} id="txt_Holiday_EditHoliday_HolidayDate" className="flatpickr tenat_form_control mdl-textfield__input" /></td>
            </tr>
                
            </div>
            <div>
                <label id="lbl_Holiday_EditHoliday_SelectBuilding" className="ChangeLimits_Modal_label">{label['ManageHolidays.Building.Text'] !== undefined ? label['ManageHolidays.Building.Text'] : "Buildings"}</label>
                <a id="link_Holiday_EditHoliday_SelectBuilding" onClick={this.nextForm} style={{ color: '#6890C6' }}>{label['ManageHolidays.SelectBuilding.Text'] !== undefined ? label['ManageHolidays.SelectBuilding.Text'] : "Select Buildings.."}</a>
            </div>
            <div>
                <div className="table_container">
                    <Table id="table_Holiday_EditHoliday_SelectBuilding" striped responsive className="Custom_table">
                        <tbody>
                            <tr>
                                <th>{label['ManageHolidays.Column.Name.Text'] !== undefined ? label['ManageHolidays.Column.Name.Text'] : "Building Name"}</th>
                                <th>{label['ManageHolidays.Column.City.Text'] !== undefined ? label['ManageHolidays.Column.City.Text'] : "City"}</th>
                                <th>{label['ManageHolidays.Column.State.Text'] !== undefined ? label['ManageHolidays.Column.State.Text'] : "State"}</th>
                            </tr>
                            {Buildingsdt}
                        </tbody>
                    </Table>
                </div>
            </div>
            <div></div>
            <br />
            
            <FormGroup row >
                <Col sm={{ size: 12 }}>
                    <Button id="btn_Holiday_EditHoliday_CancelSelectBuilding" className="btn-gray" onClick={this.CloseModal} > {label['CreateTenant.Cancel.Text']} </Button>
                    <Button id="btn_Holiday_EditHoliday_SaveSelectBuilding" className="btn-success btn-md ChangeLimits_Applybtn" onClick={this.updateHoliday} > {label['CreateTenant.Save.Text']} </Button>
                </Col>
            </FormGroup>
        </div>

        modal_form_2 = <div className="table_container">
            <SearchInput className="search-input" onChange={this.searchUpdated} />
            {errormsg1}
            <h4 className="Modal_form_title">{label['ManageHolidays.BuildingHeader.Text'] !== undefined ? label['ManageHolidays.BuildingHeader.Text'] : "Select Building(s)"}</h4>
            <Table striped responsive className="Custom_table">
                <tbody>
                    <tr>
                        <th><input type="checkbox" className="buildings_header_Check_box" onClick={() => { SelectAllCheckboxes.selectAllCheckbox("buildings_child_Check_box", "buildings_header_Check_box"); }} /></th>
                        <th>{label['ManageHolidays.Column.Name.Text'] !== undefined ? label['ManageHolidays.Column.Name.Text'] : "Building Name"} </th>
                        <th>{label['ManageHolidays.Column.City.Text'] !== undefined ? label['ManageHolidays.Column.City.Text'] : "City"}</th>
                        <th>{label['ManageHolidays.Column.State.Text'] !== undefined ? label['ManageHolidays.Column.State.Text'] : "State"}</th>
                    </tr>
                    {Available_Buildings}
                </tbody>
            </Table>
            <div>
                <FormGroup row >
                    <Col sm={{ size: 12 }}>
                        <Button id="btn_Holiday_EditHoliday_CancelEditHoliday" className="btn-black btn-md ChangeLimits_Cancelbtn" onClick={this.closePopup} >{label['CreateTenant.Cancel.Text']} </Button>
                        <Button id="btn_Holiday_EditHoliday_SaveEditHoliday" className="btn-black btn-md ChangeLimits_Applybtn" onClick={() => { this.BuildingSave(Available_Buildings); }} > {label['CreateTenant.Save.Text']}</Button>
                    </Col>
                </FormGroup>
            </div>
        </div>
        if (this.state.FormDisplay) {
            modal_form = modal_form_1
        }
        else {
            modal_form = modal_form_2
        }
        return (
            <div>
                {modal_form}
            </div>
        );
    }
    searchUpdated(term) {
        this.setState({ searchTerm: term })
    }
}

const mapStateToProps = state => {
    return {
        getResponse: state.HolidaysRootReducer,
        Response_of_Building: state.BuildingDetailsReducer,
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference,
        UserPreference_response: state.userPreferencesRootReducer.UserPreference
    };
};

const mapDispatchToProps = dispatch => {
    return {
        //GetHolidayDetails: (id) => dispatch(GetHolidayDetails(id)),
        GetBuildingsDetailsList: () => dispatch(GetBuildingsDetailsList()),
        closeModalPopUp: (data) => dispatch(closeModalPopUp(data)),
        UpdateHoliday: (data) => dispatch(UpdateHoliday(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditHolidayForm);